/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Ownership_History_ServInputs */

const en_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload ownership history, service reports, or certificates.`)
};

const es_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube el historial de propiedad, reportes de servicio o certificados.`)
};

const fr_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploadez l'historique de propriété, les rapports d'entretien ou les certificats.`)
};

const de_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade Eigentumshistorien, Serviceberichte oder Zertifikate hoch.`)
};

const ja_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有権の履歴、サービスレポート、または証明書をアップロードしてください。`)
};

const zh_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传所有权历史记录、服务报告或证书。`)
};

const ar_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم برفع تاريخ الملكية، تقارير الخدمة، أو الشهادات.`)
};

const id_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah riwayat kepemilikan, laporan layanan, atau sertifikat.`)
};

const it_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica lo storico della proprietà, i rapporti di servizio o i certificati.`)
};

const ru_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите историю владения, отчеты об обслуживании или сертификаты.`)
};

const pt_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça upload de histórico de propriedade, relatórios de serviço ou certificados.`)
};

const ko_upload_ownership_history_serv = /** @type {(inputs: Upload_Ownership_History_ServInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소유권 내역, 서비스 보고서 또는 증명서를 업로드하세요.`)
};

/**
* | output |
* | --- |
* | "Upload ownership history, service reports, or certificates." |
*
* @param {Upload_Ownership_History_ServInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_ownership_history_serv = /** @type {((inputs?: Upload_Ownership_History_ServInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Ownership_History_ServInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_ownership_history_serv(inputs)
	if (locale === "es") return es_upload_ownership_history_serv(inputs)
	if (locale === "fr") return fr_upload_ownership_history_serv(inputs)
	if (locale === "de") return de_upload_ownership_history_serv(inputs)
	if (locale === "ja") return ja_upload_ownership_history_serv(inputs)
	if (locale === "zh") return zh_upload_ownership_history_serv(inputs)
	if (locale === "ar") return ar_upload_ownership_history_serv(inputs)
	if (locale === "id") return id_upload_ownership_history_serv(inputs)
	if (locale === "it") return it_upload_ownership_history_serv(inputs)
	if (locale === "ru") return ru_upload_ownership_history_serv(inputs)
	if (locale === "pt") return pt_upload_ownership_history_serv(inputs)
	return ko_upload_ownership_history_serv(inputs)
});